// Lowercased fragments of the status messages written by the transfer services.
// Keep in step with com.nxtsoft.common.Constants in stand-alone-file-transfer.
export const STATUS_MESSAGES = {
    DOCUMENT_RETRIEVED: 'document retrieved from encompass',
    PROCESSED_FILE: 'processed file contents. adding to zip.',
    // The services vary the wording after "processed file", so match on the prefix.
    PROCESSED_FILE_PREFIX: 'processed file',
    SENDING_FILE: 'sending file',
    LOAN_FILE_EXPORTED: 'loan file exported successfully',
    TRANSFER_FAILED: 'failed to transfer file',
};
// Lowercased fragments the services write on a per-file transfer failure. More than
// one phrasing is in use: "Failed to transfer file:", "Failed to transfer zip file:",
// and "Loan file exported unsuccessfully". Matching only the first missed the other
// two, so a failed file read as in-progress or success. Anchored to these exact
// phrases rather than a bare "fail" so a benign message cannot flip a healthy run.
export const TRANSFER_FAILURE_FRAGMENTS = [
    STATUS_MESSAGES.TRANSFER_FAILED,
    'failed to transfer zip file',
    'exported unsuccessfully',
];
export const STATUS_VALUES = {
    SUCCESSFUL: 'Successful',
    // Accepted, but nothing has reported yet. Inferred from the absence of file
    // statuses, so it is paired with a recency check to stop an old malformed record
    // sitting here forever.
    QUEUED: 'Queued',
    // Documents are coming back from Encompass. Points at Encompass retrieval.
    RETRIEVING: 'Retrieving',
    // The transfer service has the batch. Points at the destination server.
    TRANSFERRING: 'Transferring',
    UNSUCCESSFUL: 'Unsuccessful',
    // Loan documents transferred, trailing documents did not. Kept separate from
    // Unsuccessful because a failed loan document can be retried from this screen and
    // a trailing document cannot.
    PARTIAL_SUCCESS: 'Partial Success',
  };
// Appended to the run status while a trailing docs run is in flight, giving
// 'Retrieving - Trailing Docs' and 'Transferring - Trailing Docs'. Display only:
// getStatus keeps returning the plain phase so comparisons against STATUS_VALUES and
// the status column sort still work. Only getStatusLabel applies this.
export const TRAILING_DOCS_STATUS_SUFFIX = ' - Trailing Docs';
// Lowercased fragments that mark a detailedStatus message as a real failure. The
// backend always writes detailedStatus but only promotes the record to Unsuccessful
// when the run has no files or a file already says failed, so a run that dies while
// carrying files from an earlier attempt keeps its old status. Keep this list
// conservative: a false positive reports a healthy run as failed.
export const DETAIL_ERROR_FRAGMENTS = [
    'failed',
    'error',
    'unable to',
    'not found',
    'timed out',
    'timeout',
    'exception',
    'unauthorized',
    'denied',
    'invalid',
  ];
// Checked before DETAIL_ERROR_FRAGMENTS and wins. "run skipped" reports a run
// deliberately not taken, and its wording otherwise trips an error match.
export const DETAIL_BENIGN_FRAGMENTS = [
    'run skipped',
  ];
// Buckets a trailing document can sit in on a history record. Mirrors FILE_STATE in
// the encompass communicator (constants/docBridgeContants.js).
export const TRAILING_DOC_STATE = {
    IN_PROCESS: 'inProcess',
    PROCESSED: 'processed',
    FAILED: 'failed',
  };
export const TRAILING_DOC_FAILED_MESSAGE =
    'Failed to transfer loan file. Please review logs for more details.';
export const TIME_THRESHOLD_MS = 600000;
// A run that is visibly moving keeps its Queued state for this long after each
// change. Slow SFTP destinations routinely take longer than TIME_THRESHOLD_MS to
// work through a batch and must not be declared stalled.
export const ACTIVITY_GRACE_MS = 2 * 60 * 1000;
// Ceiling on Queued, so a genuinely stuck loan does not sit in progress forever.
export const MAX_IN_PROGRESS_MS = 30 * 60 * 1000;
// Window in which a record counts as having just run, so two people do not resend
// the same loan.
export const JUST_RUN_WINDOW_MS = 2 * 60 * 1000;
